import Modal from 'react-modal'
import './login-modal.css';
import React from 'react';

class LoginFeedbackModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoginFeedback: false,
      preferredName: ''
    }
    this.openLoginFeedback = this.openLoginFeedback.bind(this);
    this.closeLoginFeedback = this.closeLoginFeedback.bind(this);
  }

  openLoginFeedback (preferredName) {
    this.setState({ showLoginFeedback: true });
    this.setState({ preferredName });
  }
  
  closeLoginFeedback () {
    window.location.reload()
    this.setState({ showLoginFeedback: false });
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showLoginFeedback}
          onRequestClose={this.closeLoginFeedback}
          className="Modal"
          overlayClassName="Overlay">
          <i className='bx bxs-check-circle' ></i>
          <div className="title">You’re now logged in! </div>
          <div className="info">Your name will be displayed as</div>
          <div className="name">{ this.state.preferredName }</div>
          <div className="cancel" onClick={this.closeLoginFeedback}>Click to return</div>
        </Modal>
      </div>
    );
  }
}

export default LoginFeedbackModal


// WEBPACK FOOTER //
// ./src/components/LoginFeedbackModal.js